
import React, { useEffect, useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { XCircle, Clock } from 'lucide-react';

const YapilyStatus = () => {
  const location = useLocation();

  const qrstatus = location.state?.status;
  console.log('qr status', qrstatus);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [status, setStatus] = useState(null);
  const [bgcolor, setbgcolor] = useState();
  const [textcolor, settextcolor] = useState();
  const [message, setMessage] = useState();
  const [countdown, setCountdown] = useState(10);
  // const [redirected, setRedirected] = useState(false);
  const [buttonColor, setButtonColor] = useState('from-gray-500 to-gray-600');
  const [buttonRing, setButtonRing] = useState('focus:ring-gray-400');
  const statuses = [
    'Completed',
    'Failed',
    'Cancelled',
    'Awaiting_authorization',
  ];

  useEffect(() => {
    if (!status) return;
    const interval = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          handleRedirect();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, [status]);

  useEffect(() => {
    let currentSrc = window.location.href;
    if (
      currentSrc.includes('https://login.fxmaster.co.uk/YapilyStatus') ||
      currentSrc.includes('http://login.fxmaster.co.uk/YapilyStatus') ||
      currentSrc.includes(window.location.origin + '/YapilyStatus')
    ) {
      // console.log("Full URL:", window.location.href);
      // console.log("Path:", location.pathname);
      // console.log("Query:", location.search);
      // console.log("Hash:", location.hash);

      const params = new URLSearchParams(location.search);

      const status = params.get('status') ?? qrstatus;
      const errorValue = params.get('error');

      setPaymentStatus(status);
      // setError(errorValue);

      console.log('Payment Status:', status);
      console.log('Error:', errorValue);
      setStatus(status?.toLowerCase());

      if (status?.toLowerCase() == 'pending') {
        setbgcolor('bg-orange-50');
        settextcolor('text-orange-700');
        setMessage(
          'Oops! Something went wrong during your transaction. Please wait for a while for status updates.',
        );
        setButtonColor('from-orange-500 to-orange-600');
        setButtonRing('focus:ring-orange-400');
      } else if (status?.toLowerCase() == 'failed') {
        setbgcolor('bg-red-50');
        settextcolor('text-red-700');
        setMessage('Oops! Payment Failed.');
        setButtonColor('from-red-500 to-red-600');
        setButtonRing('focus:ring-red-400');
      } else if (status?.toLowerCase() == 'cancelled') {
        setbgcolor('bg-red-50');
        settextcolor('text-red-700');
        setMessage('Oops! Payment Cancelled.');
        setButtonColor('from-red-500 to-red-600');
        setButtonRing('focus:ring-red-400');
      } else if (status?.toLowerCase() == 'completed') {
        setbgcolor('bg-green-50');
        settextcolor('text-green-700');
        setMessage(
          'Thank you for your payment. Your transaction has been completed successfully.',
        );
        setButtonColor('from-green-500 to-emerald-600');
        setButtonRing('focus:ring-green-400');
      } else if (status?.toLowerCase() == 'awaiting_authorization') {
        setbgcolor('bg-indigo-50');
        settextcolor('text-indigo-700');
        setMessage(
          'Please authorize the payment in your banking app to continue.',
        );
        setButtonColor('from-indigo-500 to-indigo-600');
        setButtonRing('focus:ring-indigo-400');
      } else {
        setbgcolor('bg-orange-50');
        settextcolor('text-orange-700');
        setMessage('Your payment is being processed.');
        setButtonColor('from-orange-500 to-orange-600');
        setButtonRing('focus:ring-orange-400');
      }
    }
  }, [location]);

  const handleRedirect = () => {
    // if (redirected) return;
    // setRedirected(true);
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isWebView = /(wv|WebView)/i.test(navigator.userAgent);

    if (isMobile || isWebView) {
      console.log('Mobile detected → opening app');

      if (paymentStatus?.toLowerCase() == 'completed')
        window.location.href = 'fxmaster://payment-success';
      else if (paymentStatus?.toLowerCase() == 'failed')
        window.location.href = 'fxmaster://payment-failed';
      else if (paymentStatus?.toLowerCase() == 'pending')
        window.location.href = 'fxmaster://payment-pending';
      else if (paymentStatus?.toLowerCase() == 'cancelled')
        window.location.href = 'fxmaster://payment-cancelled';
      else if (paymentStatus?.toLowerCase() == 'awaiting_authorization')
        window.location.href = 'fxmaster://payment-awaiting-authorization';
      else window.location.href = 'fxmaster://payment-processing';
    } else {
      console.log('Web detected → dashboard');
      window.location.href = '/transactions';
    }
  };
  const capitalize = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : str;

  return (
    <div
      className={`flex flex-col items-center justify-center h-screen ${bgcolor} p-6`}
    >
      {status == 'completed' ? (
        <CheckCircle2 className={`${textcolor} w-20 h-20 mb-5`} />
      ) : status == 'failed' || status == 'cancelled' ? (
        <XCircle className="text-red-600 w-16 h-16 mb-4" />
      ) : (
        <Clock className={`${textcolor} w-16 h-16 mb-4`} />
      )}
      <h1 className={`text-3xl font-bold mb-3 ${textcolor}`}>
        Payment{' '}
        {statuses.includes(capitalize(paymentStatus || qrstatus))
          ? capitalize(paymentStatus || qrstatus)
          : 'Processing'}
        !
      </h1>
      <p className="text-gray-700 text-center mb-8 max-w-md">{message}</p>
      <p className="text-sm text-gray-500 mb-4">
        You will be redirected to the dashboard in{' '}
        <span className="font-semibold">{countdown}</span>
      </p>
      <button
        // onClick={() => (window.location.href = '/transactions')}
        onClick={handleRedirect}
        className={`
    px-8 py-3 
    rounded-full 
    bg-gradient-to-r ${buttonColor}
    text-white 
    font-semibold 
    shadow-lg 
    hover:shadow-xl 
    transform hover:scale-105 
    transition-all 
    duration-300
    focus:outline-none 
    focus:ring-2 
    ${buttonRing}
    focus:ring-offset-2
  `}
      >
        Go Back to Dashboard
      </button>
    </div>
  );
};

export default YapilyStatus;